import { API_BASE_URL, HEADERS_WITH_TOKEN } from 'services/api/BaseUrl'

export const getAll = () =>
  fetch(
    `${API_BASE_URL}/menus`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk'))
    }
  )
  .then(res => res.json())


export const save = async (params) => {
  const res = await fetch(
    `${API_BASE_URL}/menus`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const edit = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/menus/${id}`,
    {
      method: 'PUT',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const remove = async (id) => {
  const res = await fetch(
    `${API_BASE_URL}/menus/${id}`,
    {
      method: 'DELETE',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk'))
    }
  )
  return await res.json()
}

export const getByCompany = async (id) => {
  const res = await fetch(
    `${API_BASE_URL}/menus/get-by-company/${id}`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk'))
    }
  )
  return await res.json()
}

export const updateStyle = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/menus/update-style/${id}`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const duplicate = async (params) => {
  const res = await fetch(
    `${API_BASE_URL}/menus/duplicate`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}